import React, { useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { updatePortTimeRequest } from '../../../../store/SendMessageSlice';
import TimeUpdate from '../json/timeUpdate.json';

const UpdateRequest: React.FC<any> = (props) => {
  const { openUpdateModal, handleUpdateRequest, openUpdateData, getList } =
    props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (openUpdateData) {
      form.setFieldValue('request_id', openUpdateData?.request_id);
    }
  }, [openUpdateData, form]);

  const handleSubmit = (data) => {
    dispatch(updatePortTimeRequest(data))
      .then(() => {
        handleUpdateRequest();
        getList();
      })
      .catch(() => {
        handleUpdateRequest();
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={openUpdateModal}
        destroyOnClose
        width={800}
        onCancel={handleUpdateRequest}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className='addModal'
        title={`Update Port Time Request`}>
        <FormBox
          className='filterForm'
          form={form}
          onFinish={handleSubmit}
          onChange={handleChange}
          validateTrigger={['onBlur', 'onInput']}
          autoComplete='off'>
          <Row gutter={20} align={'top'}>
            <Col xs={24} md={12}>
              <InputBox.Text
                label='Request ID'
                name={'request_id'}
                required
                rules={[
                  validations.required.text('Request ID'),
                  validations.pattern.whitespace,
                ]}
              />
            </Col>
            <Col xs={24} md={12}>
              <InputBox.Select
                label='Update Port Time By'
                name={'time'}
                allowClear
                showSearch
                initialValue={'10M'}
                options={{
                  list: TimeUpdate && TimeUpdate,
                  valueKey: 'value',
                  textKey: 'label',
                }}
                rules={[validations.required.select('Update Port Time')]}
              />
            </Col>
            <Col xs={12} md={12} lg={6}>
              <Button type='primary' htmlType='submit'>
                Submit
              </Button>
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default UpdateRequest;
